import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMostVisitedCompanies } from '@/hooks/useMostVisitedCompanies';
import { useCompanyData } from '@/contexts/CompaniesDataContext';
import { BodyCopy, Headline } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { ROUTES } from '@/routes/routes';
import { CompanyCard } from '@/components/CompanyCard';
import { FollowButton } from '@/components/FollowButton';
import { CompanyCardsSkeletonLoggedin } from '@/components/Skeleton';
import { CompanyCardContainer } from '@/components/CompanyCardContainer';
import styles from './FollowedEmptyState.css';
import { Company } from '@/types/graphql-types';

const Disclaimer = () => {
  return (
    <div className={styles.emptyStateCard}>
      <div className={styles.textLayer}>
        <Headline size="xxlarge" className={styles.text}>
          <FormattedMessage id="CP_FOLLOWED_EMPTY_STATE_HEADER" />
        </Headline>
        <BodyCopy className={styles.text}>
          <FormattedMessage id="CP_FOLLOWED_EMPTY_STATE_SUBHEADER" />
        </BodyCopy>
      </div>
      <Button
        className={styles.button}
        href={ROUTES.mostVisitedCompanies}
        size="small"
        variant="tertiary"
      >
        <FormattedMessage id="CP_FOLLOWED_EMPTY_STATE_BUTTON" />
      </Button>
    </div>
  );
};
const FollowedEmptyState = () => {
  const LIMIT = 3;
  const { data, loading } = useMostVisitedCompanies({
    limit: LIMIT,
    offset: 0,
  });
  const { addCompanies } = useCompanyData();

  useEffect(() => {
    if (data?.mostVisitedCompanies?.collection) {
      addCompanies({
        companies: data?.mostVisitedCompanies?.collection?.map(
          (item) => item?.company,
        ) as Company[],
      });
    }
  }, [data]);

  if (loading) return <CompanyCardsSkeletonLoggedin />;
  const { collection } = data?.mostVisitedCompanies ?? {};

  return (
    <>
      <Disclaimer />
      <CompanyCardContainer>
        {collection?.map((item) => {
          const company = item?.company as Company;
          const isFollowing =
            company?.userContext?.followState?.isFollowing || false;
          return (
            <CompanyCard
              key={company?.id}
              company={company}
              buttons={[
                <FollowButton
                  className={styles.followButton}
                  disabled={company?.entityPageId ? false : true}
                  entityPageId={company?.entityPageId || ''}
                  key={company?.entityPageId}
                  isFollowing={isFollowing}
                  companyId={company?.id}
                />,
              ]}
            />
          );
        })}
      </CompanyCardContainer>
    </>
  );
};

export { FollowedEmptyState };
